import { render, staticRenderFns } from "./MatomoOptOut.vue?vue&type=template&id=67bd290a&scoped=true&"
import script from "./MatomoOptOut.vue?vue&type=script&lang=js&"
export * from "./MatomoOptOut.vue?vue&type=script&lang=js&"
import style0 from "./MatomoOptOut.vue?vue&type=style&index=0&id=67bd290a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd290a",
  null
  
)

export default component.exports